module.exports = __webpack_public_path__ + "img/plat_4950.2b4db941.jpg";